module.exports = __webpack_public_path__ + "static/media/logo.c6483ef5.svg";